module.exports = __webpack_public_path__ + "static/Eat Bitter-8-3974fb804250c68871fd4cb48a9dbd3b.jpg";